<template>
  <div class="h-layout h100">
    <div class="h-right">
      <div class="h-toolbarBg">
        <!-- 按钮 -->
        <div id="toolbar_pop3">
          <ejs-toolbar>
            <e-items>
              <e-item
                prefixIcon="icon hero-icon hero-icon-topo-mc_gms"
                :text='$t("Pm.dataCollection")'
                :tooltipText='$t("Pm.dataCollection")'
                showTextOn="Overflow"
                :click="showRealData"
              ></e-item>

            </e-items>
          </ejs-toolbar>
        </div>
        <!-- <div class="h-inputBox">
          <div class="e-input-group">
            <input class="e-input" type="text" placeholder="请输入查询条件1" />
          </div>
        </div>-->
      </div>
      <div class="h-line"></div>
      <div class="h-subTabs">
        <div id="tab_wizard3"></div>
        <!-- 切换不同的测试量标准 -->
        <ejs-tab
          ref="positionOrInstructions"
          heightAdjustMode="None"
          :showCloseButton="false"
          :selected="positionOrInstructionsSelected"
        >
          <e-tabitems>
            <e-tabitem :header="headerText0" :content="content0"></e-tabitem>
            <e-tabitem :header="headerText1" :content="content0"></e-tabitem>
          </e-tabitems>
        </ejs-tab>
      </div>
      <!-- 切换内容显示区 -->
      <div id="position">
        <div class="h-scroll" style="height: calc(100vh - 240px);">
          <div class="row h-tabsRow">
            <!-- 时间范围 -->
            <div class="col-lg-2">
              <div class="h-inputLit">{{$t('Pm.timeRange')}}</div>
              <ejs-dropdownlist
                :dataSource="timeFrame"
                :placeholder="listPlaceholder"
                :fields="localFields"
                :index="0"
                :change="timeFrameChange"
              ></ejs-dropdownlist>
            </div>
            <!-- 测量位置 -->
            <div class="col-lg-2 col-lg-offset-1 positionTabClass0">
              <div class="h-inputLit">{{$t('Pm.measuringPosition')}}</div>
              <ejs-dropdownlist
                :dataSource="neFrame"
                :placeholder="listPlaceholder"
                :fields="localFields"
                v-model="dropdownNeFrameIndex"
                :change="neFrameChange"
              ></ejs-dropdownlist>
            </div>
            <!-- 测量指标 -->
            <div class="col-lg-2 col-lg-offset-1 positionTabClass1">
              <div class="h-inputLit">{{$t('Pm.indicator')}}</div>
              <ejs-dropdownlist
                :dataSource="counterFrame"
                :placeholder="listPlaceholder"
                :fields="localFields"
                v-model="dropdownCounterFrameIndex"
                :change="counterFrameChange"
              ></ejs-dropdownlist>
            </div>
          </div>
          <div class="h-line"></div>
          <!-- Echarts -->
          <RealEcharts ref="echarts1" :echartParam="echartParam1" class="positionTabClass0"></RealEcharts>
          <RealEcharts ref="echarts2" :echartParam="echartParam2" class="positionTabClass1"></RealEcharts>

          <div class="row h-tabsRow" style="margin: 15px;">
            <div class="col-lg-6">
              <div id="container" align="center"></div>
            </div>
            <div class="col-lg-6">
              <div id="container2" align="center"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 弹出数据对话框 -->
      <CustomDialog
        ref="gridForRealDataPage"
        :element="dialogForRealDataPage.element.realDataElement"
        :styles="dialogForRealDataPage.stylesSearch"
        :contentMethod="dialogForRealDataPage.contentMethod"
      >
        <template v-slot:dialog-content>
          <GridForRealData ref="gridForRealData" :gridForRealDataCache="gridForRealDataCache"></GridForRealData>
        </template>
      </CustomDialog>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import echarts from 'echarts';
import { Script } from 'vm';
import RealEcharts from './RealEcharts';
import CustomDialog from '../../common/CustomDialog';
import GridForRealData from './GridForRealData';
import pmRealTimeDataReceive from '@/plugins/stompSock';
import commonUtil from './commonUtil';

Vue.prototype.$echarts = echarts;

export default {
  name: 'RealTaskTab',
  components: { RealEcharts, CustomDialog, GridForRealData },
  data() {
    return {
      // 实时数据弹出页面参数
      dialogForRealDataPage: {
        stylesSearch: {
          width: '80%',
          height: '80%',
          visible: false,
          model: true
        },
        element: {
          realDataElement: {
            title: this.$t('Pm.dataCollection'),
            target: '#app',
            refName: 'realDataElement',
            buttonGroup: [
              {
                click: this.closeRealDataPage,
                buttonModel: { content: this.$t('Pm.cancel') }
              },
              {
                click: this.confirmRealDataPage,
                buttonModel: {
                  content: this.$t('Pm.confirm'),
                  isPrimary: true
                }
              }
            ],
            isClose: true
          }
        }
      },
      echartParam1: { id: 'mainAnaylsis1' },
      echartParam2: { id: 'mainAnaylsis2' },
      listPlaceholder: '',
      localFields: { text: 'name', value: 'value' },
      // 时间下拉选项
      timeFrame: [
        {
          name: this.$t('Pm.oneMinute'),
          value: '1'
        },
        {
          name: this.$t('Pm.fiveMinutes'),
          value: '5'
        },
        {
          name: this.$t('Pm.tenMinutes'),
          value: '10'
        },
        {
          name: this.$t('Pm.twentyMinutes'),
          value: '20'
        },
        {
          name: this.$t('Pm.all'),
          value: '0'
        }
      ],
      // 测量位置的下拉选项
      neFrame: [], // [{name:"811",value:"811"},{name:"812",value:"812"}],
      // 测量对象的下拉选项
      counterFrame: undefined,
      // 当前选中的指标
      selectCount: undefined,
      // 当前选中的网元
      selectNe: undefined,
      headerText0: {
        text: this.$t('Pm.bySeat')
      },
      headerText1: {
        text: this.$t('Pm.byIndicator')
      },
      content0: '#position',
      myChart: undefined,
      myChartData: [],
      myChartData2: [],
      chartstimescope: 1,
      lastcharttime: 0,
      gridForRealDataCache: [],
      setIntervalName1: undefined,
      taskConfig: undefined,
      configcounterinfos: undefined,
      dropdownNeFrameIndex: '',
      dropdownCounterFrameIndex: '',
      // websocket连接参数
      payload: [
        { topic: '/user/#/PmCurrenttimeWsServer', clientId: '', callback: this.pmRealTimeDataReceiveLisener }
      ]
    };
  },
  mounted() { },

  methods: {
    async startup(taskConfig) {
      const _this = this;
      console.log('startup-websocket', pmRealTimeDataReceive.socket)

      // 模拟 建立websock同时订阅主题
      if (!pmRealTimeDataReceive.socket || pmRealTimeDataReceive.socket.readyState == 2 || pmRealTimeDataReceive.socket.readyState == 3) {
        this.payload[0].clientId = taskConfig.taskId;
        pmRealTimeDataReceive.init(this.payload);
      }else{
        console.log('subscribes', pmRealTimeDataReceive.subscribes);
        if(pmRealTimeDataReceive.subscribes[pmRealTimeDataReceive.__buildSubscribeTopic(taskConfig.taskId,this.payload[0].topic)]){
          // 主题已经存在无需特别处理
        }else{
          pmRealTimeDataReceive.dynamicSubscribe(this.payload[0].topic, taskConfig.taskId, this.payload[0].callback);
        }
      }

      // 查询测量对象
      this.taskConfig = taskConfig;
      let params = {};
      params.counterTypeId = this.taskConfig.counterTypeId;
      params.neVersionId = this.taskConfig.neVersionId;
      params.neTypeId = this.taskConfig.neTypeId;

      await this.$axios
        .get(`/lte/pm/currenttime/collect/getConfigCounterInfos.html${commonUtil.analyticParameter(params)}`, {})
        .then(response => {
          // 查询回来的数据包括包该类型下的全部指标，需要和用户选择项进行过滤
          let data = response.data;
          // 过滤后的有用数据
          let useData = [];

          for (let i = 0; i < data.length; i++) {
            for (let k = 0; k < _this.taskConfig.measureIndicators.length; k++) {
              if (_this.taskConfig.measureIndicators[k].counterCode == data[i].counterCode) {
                useData.push(data[i]);
              }
            }

          }
          // 模拟数据需要修改成data
          _this.configcounterinfos = useData;
        });

      this.counterFrame = this.getConfigCounterInfos();

      // 查询网测量位置
      params = {};
      params.taskId = this.taskConfig.taskId;
      await this.$axios
        .get(`/lte/pm/currenttime/collect/getSeatsByTaskId.html${commonUtil.analyticParameter(params)}`, {})
        .then(response => {
          let neFrameTemp = [];
          for (let index = 0; index < response.data.length; index++) {
            // 下拉菜单默认选择第一个选项
            if (index === 0) {
              _this.dropdownNeFrameIndex = response.data[index];
            }
            neFrameTemp.push({
              name: response.data[index],
              value: response.data[index]
            });
          }
          // 如果直用push方法，则无法选中第一个选项
          _this.neFrame = neFrameTemp;
        });

      // 初始化图表参数
      this.init(this);

      this.myChartData.length = this.configcounterinfos.length;
      for (let i = 0; i < this.myChartData.length; i++) {
        this.myChartData[i] = {};
        this.myChartData[i].data = [];
      }

      this.myChartData2.length = this.neFrame.length;
      for (let i = 0; i < this.myChartData2.length; i++) {
        this.myChartData2[i] = {};
        this.myChartData2[i].data = [];
      }

      // 选中默认的标签(按位置)
      let args = {};
      args.selectedIndex = 0;
      this.positionOrInstructionsSelected(args);

      // 模拟sockect数据
      // this.setIntervalName1 = setInterval(function () {
      //   _this.createSeriesData(true);
      // }, 9000);
    },
    shutdown() {
      clearInterval(this.setIntervalName1);

      console.log('shutdown-websocket', pmRealTimeDataReceive.socket)
      // 取消websocket订阅
      if (pmRealTimeDataReceive.socket.readyState == 0 || pmRealTimeDataReceive.socket.readyState == 1) {
        pmRealTimeDataReceive.stopReceiveTopicMsg(this.taskConfig.taskId, this.payload[0].topic);
      }

      this.myChartData = [];
      this.myChartData2 = [];
      this.gridForRealDataCache = [];

      this.$refs.echarts1.myChartClear();
      this.$refs.echarts2.myChartClear();
    },
    showRealData() {
      this.$refs.gridForRealDataPage.show();
      if (this.gridForRealDataCache.length > 0) {
        this.$refs.gridForRealData.addAction(this.gridForRealDataCache);
      }
    },
    confirmRealDataPage() {
      this.$refs.gridForRealDataPage.close();
    },
    closeRealDataPage() {
      this.$refs.gridForRealDataPage.close();
    },
    init(_this) {
      // 指定图表的配置项和数据
      var option1 = {
        title: {
          text: this.$t('Pm.realTimeBySeat'),
          x: 'center'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params11) {
            var result = `${params11[0].value[0]}<br/>`;
            for (var i = 0; i < params11.length; i++) {
              result += `${params11[i].seriesName}:${params11[i].value[1]}<br/>`;
            }
            return result;
          }
        },
        legend: {
          data: (function () {
            let icategory = [];
            for (
              let index = 0;
              index < _this.configcounterinfos.length;
              index++
            ) {
              icategory.push((_this._i18n.locale === 'zh')?_this.configcounterinfos[index].counterCodeCn:_this.configcounterinfos[index].counterCodeEn);
            }
            return icategory;
          })(),
          left: 'center',
          top: '30'
        },
        grid: {
          y: 100
        },
        dataZoom: {
          show: true,
          start: 0
        },
        xAxis: {
          type: 'time',
          splitLine: {
            // show: false
          },
          splitNumber: 10,
          boundaryGap: false
        },
        yAxis: { name: (_this._i18n.locale === 'zh')?_this.configcounterinfos[0].counterUnitCn:_this.configcounterinfos[0].counterUnitEn },
        series: []
      };

      this.$refs.echarts1.myChartSetOption(option1);

      // 指定图表的配置项和数据
      var option2 = {
        title: {
          text: this.$t('Pm.realTimeByIndicator'),
          x: 'center'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params11) {
            var result = params11[0].value[0] + "<br/>";
            for (var i = 0; i < params11.length; i++) {
              result +=
                params11[i].seriesName + ":" + params11[i].value[1] + "<br/>";
            }
            return result;
          }
        },
        legend: {
          data: (function () {
            let icategory = [];
            for (let index = 0; index < _this.neFrame.length; index++) {
              icategory.push(_this.neFrame[index].name);
            }
            return icategory;
          })(),
          left: 'center',
          top: '30'
        },
        grid: {
          y: 100
        },
        dataZoom: {
          show: true,
          start: 0
        },
        xAxis: {
          type: 'time',
          splitLine: {
            // show: false
          },
          splitNumber: 10,
          boundaryGap: false
        },
        yAxis: { name: (_this._i18n.locale === 'zh')?_this.configcounterinfos[0].counterUnitCn:_this.configcounterinfos[0].counterUnitEn },
        series: []
      };

      this.$refs.echarts2.myChartSetOption(option2);
    },
    getConfigCounterInfos() {
      let counter = [];
      for (let index = 0; index < this.configcounterinfos.length; index++) {
        if (index === 0) {
          this.dropdownCounterFrameIndex = this.configcounterinfos[index].counterCode;
        }
        counter.push({
          name: (this._i18n.locale === 'zh')?this.configcounterinfos[index].counterCodeCn:this.configcounterinfos[index].counterCodeEn,
          value: this.configcounterinfos[index].counterCode
        });
      }
      return counter;
    },
    deepCopy(source) {
      var sourceCopy = source instanceof Array ? [] : {};
      for (var item in source) {
        sourceCopy[item] =
          typeof source[item] === 'object'
            ? this.deepCopy(source[item])
            : source[item];
      }
      return sourceCopy;
    },
    timeFrameChange(args) {
      this.chartstimescope = args.value;
      this.createSeriesData(false);
    },
    neFrameChange(args) {
      this.selectNe = args.value;
      this.createSeriesData(false);
    },
    counterFrameChange(args) {
      this.selectCount = args.value;
      this.createSeriesData(false);
    },
    positionOrInstructionsSelected(args) {
      let positionTabClass0 = document.getElementsByClassName(
        'positionTabClass0'
      );
      let positionTabClass1 = document.getElementsByClassName(
        'positionTabClass1'
      );

      if (args.selectedIndex == 0) {
        for (var index = 0; index < positionTabClass0.length; index++) {
          positionTabClass0[index].style.display = 'block';
        }
        for (var index = 0; index < positionTabClass1.length; index++) {
          positionTabClass1[index].style.display = 'none';
        }
      }
      if (args.selectedIndex == 1) {
        for (var index = 0; index < positionTabClass0.length; index++) {
          positionTabClass0[index].style.display = 'none';
        }
        for (var index = 0; index < positionTabClass1.length; index++) {
          positionTabClass1[index].style.display = 'block';
        }
      }
    },
    // isData是否有数据更新
    createSeriesData(isData) {
      // 判断当前用户是否在性能实时任务下，如果用户离开页面，需要关闭一系列的资源
      if (this.$route.path != '/pm/realTimeTask') {
        this.shutdown();
        return;
      }

      if (isData) {
        // 模拟websocket测试数据
        // let socketData = this.randomData()[0];
        let socketData = isData[0];
        this.setGridForRealDataCache(socketData);

        // 图表的横坐标是时间轴
        var tmp =
          (socketData.start_time[0] == "1" ? '20' : '') +
          socketData.start_time
            .split(' ')[0]
            .split('-')
            .join('/') +
          ' ' +
          socketData.start_time.split(' ')[1];

        this.lastcharttime = tmp;
        // 处理按位置图表的数据生成
        for (let index = 0; index < this.configcounterinfos.length; index++) {
          this.myChartData[index].type = 'line';
          this.myChartData[index].name = (this._i18n.locale === 'zh')?this.configcounterinfos[index].counterCodeCn:this.configcounterinfos[index].counterCodeEn;

          let item = {};

          // item.name = new Date().toString();
          item.value = [];
          item.value.push(tmp);
          item.value.push(
            socketData[this.configcounterinfos[index].counterCode]
          );
          item.value.push( !!socketData.assoc_id?(socketData.ne_id + "_" + socketData.assoc_id):socketData.ne_id );

          if (this.myChartData[index].data.length > 100) {
            this.myChartData[index].data.shift();
          }
          this.myChartData[index].data.push(item);
        }

        // 处理按指标图表的数据生成
        for (let k = 0; k < this.neFrame.length; k++) {
          this.myChartData2[k].type = 'line';
          this.myChartData2[k].name = this.neFrame[k].name;

          if (this.myChartData2[k].data.length > 100) {
            this.myChartData2[k].data.shift();
          }

          if (this.myChartData2[k].name != socketData.ne_id && this.myChartData2[k].name != socketData.ne_id + "_" + socketData.assoc_id) {
            continue;
          }

          for (let attribute in socketData) {
            if (attribute.indexOf('0') >= 0) {
              let item = {};
              item.value = [];
              item.value.push(tmp);
              item.value.push(socketData[attribute]);
              item.value.push(attribute);
              this.myChartData2[k].data.push(item);
            }
          }
        }
      }

      let seriesnow = undefined;

      // 过滤指标数据
      seriesnow = this.deepCopy(this.myChartData2);

      for (var j = 0; j < seriesnow.length; j++) {
        let datalength = seriesnow[j].data.length;
        for (var i = datalength - 1; i >= 0; i--) {
          let selectCount = this.selectCount
            ? this.selectCount
            : this.counterFrame[0].value;
          if (!(selectCount == seriesnow[j].data[i].value[2])) {
            seriesnow[j].data.splice(i, 1);
            continue;
          }

          // 仅入时符合时间段内的数据
          if (this.chartstimescope != 0) {
            let thisdate = new Date(seriesnow[j].data[i].value[0]);
            let timenow =
              tmp == null ? new Date(this.lastcharttime) : new Date(tmp);
            if (timenow - thisdate > this.chartstimescope * 60000) {
              seriesnow[j].data.splice(i, 1);
            }
          }
        }
      }

      // console.log("echarts2.myChartSetOption", JSON.stringify(seriesnow));
      // 防止第一次下拉选项触发的无数据变更
      if (seriesnow[0] && seriesnow[0].data.length > 0) {
        this.$refs.echarts2.myChartSetOption({ series: seriesnow });
      }

      seriesnow = this.deepCopy(this.myChartData);

      for (let j = 0; j < seriesnow.length; j++) {
        var datalength = seriesnow[j].data.length;
        for (var i = datalength - 1; i >= 0; i--) {
          // 仅放入测量位置指定的网元ID的数据
          if (
            seriesnow[j].data[i].value[2] !=
            (this.selectNe ? this.selectNe : this.neFrame[0].value)
          ) {
            seriesnow[j].data.splice(i, 1);
            continue;
          }
          // 仅入时符合时间段内的数据
          if (this.chartstimescope != 0) {
            let thisdate = new Date(seriesnow[j].data[i].value[0]);
            let timenow =
              tmp == null ? new Date(this.lastcharttime) : new Date(tmp);
            if (timenow - thisdate > this.chartstimescope * 60000) {
              seriesnow[j].data.splice(i, 1);
            }
          }
        }
      }

      // console.log('echarts1.myChartSetOption',JSON.stringify(seriesnow));
      // 防止第一次下拉选项触发的无数据变更
      if (seriesnow[0] && seriesnow[0].data.length > 0) {
        this.$refs.echarts1.myChartSetOption({ series: seriesnow });
      }
    },
    setGridForRealDataCache(socketData) {
      if (this.gridForRealDataCache.length > 100) {
        this.gridForRealDataCache.pop();
      }

      let tableData = {};
      // 基本数据结构
      tableData["sys_meter_timely_task_id"] = socketData.sys_meter_timely_task_id;
      tableData["ne_id"] = socketData.ne_id;
      tableData["ne_name"] = socketData.ne_name;
      tableData["statistic_cycle"] = socketData.statistic_cycle;
      tableData["Intodb_time"] = socketData.Intodb_time;
      //各网元的特殊处理
      if (socketData.ne_type_id == 101) {
        tableData["assoc_id"] = socketData.assoc_id;
      }

      if (socketData.ne_type_id == 106 || socketData.ne_type_id == 107) {
        tableData["proId"] = socketData.proId;
      }

      // 建立实时任务时用户选择的指标
      for (let index = 0; index < this.configcounterinfos.length; index++) {
        tableData[(this._i18n.locale === 'zh')?this.configcounterinfos[index].counterCodeCn:this.configcounterinfos[index].counterCodeEn] =
          socketData[this.configcounterinfos[index].counterCode];
      }

      this.gridForRealDataCache.unshift(tableData);
      this.$refs.gridForRealData.addAction(tableData);
    },
    // websocket回调函数
    pmRealTimeDataReceiveLisener(response) {
      console.log('pmRealTimeDataReceiveLisener', response);
      let msg = JSON.parse(response.body);
      this.createSeriesData(msg);
    },
    exportRealData() {
      console.log('exportRealData');
    },
    randomData() {
      function left0(sec) {
        if (String(sec).length == 1) {
          return `0${sec}`;
        }

        return sec;
      }

      let now = new Date();
      // let oneDay = 24 * 3600 * 1000;
      let value1 = Math.random() * 1000;
      let value2 = Math.random() * 1000;

      value1 = value1 + Math.random() * 21 - 10;
      value2 = value2 + Math.random() * 21 - 10;
      let startTime =
        [now.getFullYear(), now.getMonth() + 1, now.getDate()].join('-') +
        ' ' +
        [now.getHours(), left0(now.getMinutes()), left0(now.getSeconds())].join(':');

      let webSocketData = {
        C0000016384: 'NULL',
        C0000016385: 'NULL',
        C0000016386: 'NULL',
        C0000016387: parseInt(String(value1)),
        C0000016388: parseInt(String(value2)),
        Intodb_time: startTime,
        alarm_flag: '0',
        assoc_id: '1',
        data_bilievable: '1',
        data_time_type: '0',
        end_time: '2018-09-22 02:45:23',
        ne_id: '811',
        ne_name: 'ENB',
        ne_type_id: '101',
        start_time: startTime,
        statistic_cycle: '5',
        sys_meter_timely_task_id: '20191125154544'
      };

      // 模拟两个测量位置
      if (parseInt(Math.random() * 10) % 2 == 0) {
        webSocketData.ne_id = 812;
        webSocketData.ne_name = 'ENA';
      }

      let data = [];
      data.push(webSocketData);
      return (function () {
        return data;
      })();
    }
  }
};
</script>
<style></style>;
